export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Canal de venta',
	plural_model_name_spanish: 'Canales de venta',
	create_model_name_spanish: 'Nuevo Canal de venta',
	text_delete: 'el',
}